import { makeStyles, Theme } from "@material-ui/core/styles";

export const QuickWinsContainerStyles = makeStyles((theme: Theme) => ({
  container: {
    fontSize: theme.typography.pxToRem(30),
  },
  sectionTitle: {
    fontSize: theme.typography.pxToRem(30),
    color: "#0F172A",
    fontFamily: "Inter",
    fontWeight: 600,
    margin: "5px 0 20px",
  },
  tabTitle: {
    fontSize: theme.typography.pxToRem(16),
    fontFamily: "Lato",
    fontWeigth: 400,
  },
}));
